// extracted by css-extract-rspack-plugin
module.exports =  {"questionBox":"mud19","optionTitle":"Nha1X","optionDesc":"xdeuN","infoIcon":"q7K6D"};